import api from "../../../../shared/api.jsx";

const base = (leadId) =>
  `/leads/${encodeURIComponent(String(leadId))}/bidding`;

export async function publishLead(leadId) {
  return api.post(`${base(leadId)}/publish`);
}

export async function closeBidding(leadId) {
  return api.post(`${base(leadId)}/close`);
}

export async function unpublishLead(leadId) {
  return api.post(`${base(leadId)}/unpublish`);
}

export async function updateBiddingClosesAt(leadId, closesAt) {
  return api.patch(`${base(leadId)}/closes-at`, { closesAt });
}

export async function getBids(leadId) {
  return api.get(`${base(leadId)}/bids`);
}

export async function createManualBid(leadId, data) {
  return api.post(`${base(leadId)}/bids`, data);
}

export async function deleteBid(leadId, bidId) {
  return api.delete(`${base(leadId)}/bids/${encodeURIComponent(String(bidId))}`);
}

export async function getOptions(leadId) {
  return api.get(`${base(leadId)}/options`);
}

export async function upsertOption(leadId, data) {
  return api.post(`${base(leadId)}/options`, data);
}

export async function deleteOption(leadId, optionId) {
  return api.delete(`${base(leadId)}/options/${optionId}`);
}

export async function previewOptionsPackage(leadId) {
  return api.get(`${base(leadId)}/options/preview`);
}

export async function sendOptionsPackage(leadId) {
  return api.post(`${base(leadId)}/options/send`);
}

export async function chooseOption(leadId, optionId) {
  return api.post(`${base(leadId)}/options/${optionId}/choose`);
}

export async function createQuoteFromOption(leadId, optionId) {
  return api.post(`${base(leadId)}/options/${optionId}/create-quote`);
}
